import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const SubRow: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        border-bottom: 1px solid ${theme.colours.silver2};
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default SubRow;
